import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {AdminService} from '../../../services/admin.service';
import {NotificationsService} from '../../../services/notifications.service';
import {
  AppNotification,
  ClothingNotificationRoutingService
} from '../../../services/clothing-notification-routing.service';
import { ClothingNotificationActionService } from '../../../services/clothing-notification-action.service';

@Component({
  selector: 'app-from-email-link',
  templateUrl: './from-email-link.component.html',
  styleUrls: ['./from-email-link.component.css']
})
export class FromEmailLinkComponent implements OnInit {
  public isLoaded = false;
  private notificationID;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private notificationsService: NotificationsService,
              private userService: UserService,
              public stepsControllerService: StepsControllerService,
              private adminService: AdminService,
              private clothingNotificationRoutingService: ClothingNotificationRoutingService,
              private clothingNotificationActionService: ClothingNotificationActionService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.notificationID = params['id'];
      this.startEmailNotification();
    });

    // this.startEmailNotification();
  }

  startEmailNotification() {
    this.isLoaded = false;
    this.userService.getNotificationByID(this.notificationID).subscribe(
      (res: any) => {
        if (res.status === 200) {
          // TODO смотреть что за нотификация и если по SL то кидать в еще один такой метод
          // TODO сделать метод openNotification для SL

          const notificationFromEmail = res.body;
          // http://localhost/email-notification/5b30f6cc503e965f4457fd00
          if (this.isClothingNotification(notificationFromEmail)) {
            if (this.isViewedClothingNotification(notificationFromEmail)) {
              this.isLoaded = true;
              return;
            }
            this.openClothingNotification(notificationFromEmail);
          } else if (notificationFromEmail.category !== 'GLOBAL') {
            this.openSLNotification(res.body.suggestionId, res.body.type, res.body);
          } else {
            this.openNotification(res.body.standardId, res.body.type, res.body.status);
          }
        }
      },
      (err) => {
        if (err.status === 412) {
          // Возможно действие уже было сделано
          console.warn('Возможно действие уже было сделано');
        } else {
          // Ошибка открытия нотификации
          console.warn('Ошибка открытия нотификации');
        }
        this.isLoaded = true;
      }
    );
  }

  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK

  openNotification(sID, sType, sStatus) {
    switch (sType) {
      case 'CONFIRMATION_STARTED':
        this.router.navigate(['/dashboard/confirm-standard/' + sID]);
        break;
      case 'MODIFY_REQUEST':
        this.stepsControllerService.setNotifyType('MODIFY REQUEST');
        this.modifyActionDo(sID, true, 'MODIFY REQUEST', 'STNDR');
        break;
      case 'CONFIRMATION_FINISHED':
        this.stepsControllerService.setNotifyType('CONFIRMATION FINISHED');
        this.modifyActionDo(sID, true, 'CONFIRMATION FINISHED', 'STNDR');
        break;
      case 'NEW_MESSAGE':
        this.modifyActionDo(sID, true, 'NEW MESSAGE', 'STNDR');
        break;
      case 'CONF_CHAT_MESSAGE':
        this.modifyActionDo(sID, true, 'CONF_CHAT_MESSAGE', 'STNDR');
        break;
      case 'FAMILIARIZATION_STARTED':
        this.router.navigate(['/dashboard/familiarize-standard/' + sID]);
        break;
      case 'FAMILIARIZATION_FINISHED':
        this.stepsControllerService.setNotifyType('FAMILIARIZATION FINISHED');
        this.modifyActionDo(sID, true, 'FAMILIARIZATION FINISHED', 'STNDR');
        break;
      case 'MODIFICATION_DONE':
        this.router.navigate(['/dashboard/confirm-standard/' + sID]);
        break;
      case 'TESTING_STARTED':
        this.router.navigate(['/dashboard/familiarize-standard/' + sID]);
        break;
      case 'TRANSLATED_MAIN_INFO_DONE':
        this.stepsControllerService.setNotifyType('CONFIRMATION FINISHED');
        this.modifyActionDo(sID, true, 'CONFIRMATION FINISHED', 'STNDR');
        break;
      case 'TRANSLATION_COMPLETED':
        this.stepsControllerService.setNotifyType('FAMILIARIZATION FINISHED');
        this.modifyActionDo(sID, true, 'FAMILIARIZATION FINISHED', 'STNDR');
        break;
    }

  }


  openSLNotification(slID, sType, stnd) {
    switch (sType) {
      case 'ADDED_SUGGESTION_FOR_REVIEW':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'ADDED SUGGESTION FOR REVIEW', 'SL');
        break;
      case 'SUGGESTION_CANCELLED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION CANCELLED', 'SL');
        break;
      case 'SUGGESTION_IMPLEMENTED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION IMPLEMENTED', 'SL');
        break;
      case 'SUGGESTION_POSTPONED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION POSTPONED', 'SL');
        break;
      case 'SUGGESTION_REASSIGNED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION REASSIGNED', 'SL');
        break;
      case 'SUGGESTION_POSTPONE_EXPIRED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION POSTPONE_EXPIRED', 'SL');
        break;
      case 'ALL_SUGGESTION_TASKS_DONE':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'ALL SUGGESTION TASKS DONE', 'SL');
        break;
      case 'SUGGESTION_TASK_WORK':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION TASK WORK', 'SL');
        break;
      case 'SUGGESTION_TASKS_EXPIRED':
        this.notificationsService.readNotification(stnd.category, slID, stnd.id);
        this.modifyActionDo(slID, true, 'SUGGESTION TASK WORK', 'SL');
        break;
    }

  }

  private isClothingNotification(notification: AppNotification): boolean {
    return this.clothingNotificationRoutingService.isClothingNotification(notification);
  }

  private isViewedClothingNotification(notification: AppNotification): boolean {
    return this.isClothingNotification(notification) && !!notification.viewed;
  }

  private openClothingNotification(notification: AppNotification): void {
    this.clothingNotificationActionService.openNotification(notification);
  }


  modifyActionDo(sID, toSteps, status, objectTxt) {
    // IF STANDARD
    if (objectTxt === 'STNDR') {
      this.adminService.getStandard(sID).subscribe(
        (response: any) => {
          if (response.status === 200) {
            const standard = response.body;

            if (status === 'NEW MESSAGE') {
              this.router.navigate(['/dashboard/confirm-standard/' + sID]);
            } else {
              if (this.userService.getLocal().id === standard.author.id) {
                if (toSteps) {
                  this.stepsControllerService.setCurrentStandard(standard);
                }
              } else {
                this.router.navigate(['/dashboard/confirm-standard/' + sID]);
              }
            }

          }
        },
        () => {
        });
    } else if (objectTxt === 'SL') {
      // IF SL
      this.router.navigate(['/dashboard/suggestion-list-details/' + sID]);
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/from-email-link/from-email-link.component.ts